import { jsx as _jsx } from "react/jsx-runtime";
const Loading = (props) => _jsx("div", { className: "container-lg py-5 text-center text-muted", children: "Loading\u2026" });
export default Loading;
